import React from "react";
import Icon from "assets/icons";
import Button from "shared/components/button";
import useDatePickerHeaderService from "./service";
import { DatePickerHeaderProps, YearOptionButtonProps, YearSelectDropdownProps } from "./types";
import { YEAR_SELECTOR_ID } from "shared/utils/constants";

export default function DatePickerHeader(props: DatePickerHeaderProps) {
  const service = useDatePickerHeaderService(props);
  return (
    <div className="datePicker--header">
      <div
        data-testid="header-year-selector"
        className="datePicker--header_year"
        onClick={service.openYearSelectorHandler}>
        <span className="datePicker--header_year--monthText">{service.selectedMonth}</span>
        <span className="datePicker--header_year--yearText">{service.selectedYear}</span>
        <Button icon={<Icon.ArrowDown />} />
      </div>

      {service.openYearSelector && (
        <YearSelectDropdown selectedYearIndex={service.selectedYearIndex}>
          {service.years.map(option => (
            <YearOptionButton
              key={option}
              year={option}
              isSelected={service.selectedYear === option}
              changeHandler={service.changeYearHandler}
            />
          ))}
        </YearSelectDropdown>
      )}

      {/**Need to hide month change button when year selector is open */}
      {!service.openYearSelector && (
        <div className="datePicker--header_monthSelector">
          <Button
            onClick={props.decreaseMonth}
            testId="previous-month-button"
            icon={<Icon.ArrowLeft />}
            disabled={props.prevMonthButtonDisabled}
          />
          <Button
            onClick={props.increaseMonth}
            testId="next-month-button"
            icon={<Icon.ArrowRight />}
            disabled={props.nextMonthButtonDisabled}
          />
        </div>
      )}
    </div>
  );
}

function YearSelectDropdown(props: YearSelectDropdownProps) {
  const ref = React.useRef<any>();

  React.useEffect(() => {
    if (ref.current) {
      //Open selected year in center.
      const selectedOption = ref.current.children[props.selectedYearIndex];
      const yearSelector = ref.current;
      ref.current.scrollTop +=
        selectedOption.getBoundingClientRect().top -
        yearSelector.getBoundingClientRect().top -
        ref.current.clientHeight / 2;
    }
  }, [props.selectedYearIndex]);

  return (
    <div
      ref={ref}
      data-testid="year-selector-dropdown"
      className="datePicker--header_yearSelector"
      id={YEAR_SELECTOR_ID}>
      {props.children}
    </div>
  );
}

function YearOptionButton(props: YearOptionButtonProps) {
  return (
    <Button
      className={props.isSelected ? "selectedYear" : ""}
      isOutline={props.isSelected}
      label={props.year.toString()}
      onClick={() => props.changeHandler(props.year)}
    />
  );
}
